
import * as actionTypes from '../actions/actionTypes';

const initialState = {
    selectedCompany: null,
    tintColor: '#FFC100',
    shop: null,
    shopLoading: false,
    shopId: null,
    shops: null,
    loyaltyInformation: null,
    groupFilterOptions: {},
    activeFilters: {
        employees: [],
        services: [],
        objects: [],
    },
    promotions: [],
};

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.GET_COMPANY_INFO_SUCCEEDED:
            return {
                ...state,
                selectedCompany: action.companyInfo,
                tintColor: action.companyInfo.company.app_color
            };
        case actionTypes.GET_SHOP:
            return {
                ...state,
                shop: null,
                shopId: action.shopID,
                shopLoading: true,
            };
        case actionTypes.GET_SHOP_SUCCEEDED:
            return {
                ...state,
                shop: action.shop,
                shopId: action.shopId,
                shopLoading: false,
            };
        case actionTypes.GET_SHOP_FAILED:
            return {
                ...state,
                shop: null,
                shopId: null,
                shopLoading: false,
            };
        case actionTypes.GET_SHOP_LIST_SUCCEEDED:
            const {shops} = action;
            return {
                ...state,
                shops
            };
        case actionTypes.GET_LOYALTY_INFORMATION_SUCCEEDED:
            const {points_for_online_payment: pointsForOnlinePayment, discount, current_discount: currentDiscount, need_points: needPoints, loyalty_description: loyaltyDescription} = action.payload;

            return {
                ...state,
                loyaltyInformation: {
                    pointsForOnlinePayment,
                    discount,
                    currentDiscount,
                    needPoints,
                    loyaltyDescription
                }
            };
        case actionTypes.GET_GROUP_FILTER_OPTIONS_SUCCEEDED:
            return {
                ...state,
                groupFilterOptions: action.payload,
            };
        case actionTypes.SET_ACTIVE_FILTERS:
            return {
                ...state,
                activeFilters: action.payload,
            };
        case actionTypes.SET_PROMOTIONS:
            return {
                ...state,
                promotions: action.payload,
            };
        default:
            return {
                ...state
            }
    }
};

export default reducer;
